import React from 'react';
import { observer } from 'mobx-react-lite';

import { ExportFormat, ShareableAssetType } from '@clipr/lib';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { ShareMeetingAssetsWindowState } from './shareMeetingAssetsWindowState';
import './shareMeetingAssetsWindow.scss';

type Props = {
  model: ShareMeetingAssetsWindowState;
  visible?: boolean;
};

export const ShareMeetingAssetsWindow = observer((props: Props) => {
  const { model } = props;

  return (
    <Window
      model={model.window}
      visible={props.visible}
      className="share-assets-window"
    >
      <WindowHeader model={model.window} title="Share Assets" />
      <hr />
      <div className="window-content share-assets">
        {model.documentRows.length > 0 && (
          <section className="share-section">
            <div className="share-section-title">EXPORT DOCUMENTS</div>
            {model.documentRows.map(asset => (
              <DocumentRow key={asset} model={model} asset={asset} />
            ))}
          </section>
        )}

        {(model.hasAudio || model.hasVideo) && (
          <section className="share-section">
            <div className="share-section-title">EXPORT MEDIA</div>
            {model.hasAudio && (
              <MediaRow model={model} asset={ShareableAssetType.Audio} />
            )}
            {model.hasVideo && (
              <MediaRow model={model} asset={ShareableAssetType.Video} />
            )}
          </section>
        )}
      </div>
    </Window>
  );
});

const DocumentRow = observer(
  ({ model, asset }: { model: ShareMeetingAssetsWindowState; asset: ShareableAssetType }) => (
    <div className="share-asset-row">
      <span className="share-asset-label">{model.assetLabel(asset)}</span>
      <div className="share-asset-actions">
        <Button
          className="share-action"
          label="PDF"
          disabled={model.isBusy(`${asset}:${ExportFormat.Pdf}`)}
          onClick={() => model.exportDocument(asset, ExportFormat.Pdf)}
        />
        <Button
          className="share-action"
          label="Word"
          disabled={model.isBusy(`${asset}:${ExportFormat.Docx}`)}
          onClick={() => model.exportDocument(asset, ExportFormat.Docx)}
        />
      </div>
    </div>
  ),
);

const MediaRow = observer(
  ({ model, asset }: { model: ShareMeetingAssetsWindowState; asset: ShareableAssetType }) => (
    <div className="share-asset-row">
      <span className="share-asset-label">{model.assetLabel(asset)}</span>
      <div className="share-asset-actions">
        <Button
          className="share-action share-action-filled"
          label="Share"
          disabled={model.isBusy(asset)}
          onClick={() => model.shareMedia(asset)}
        />
      </div>
    </div>
  ),
);
